import { PushMessageType } from '@core/models/user/enums';
export interface IQueueMessage {
    type?: PushMessageType;
    resume: (() => void);
}
export interface IMessagesState {
    isPaused: boolean;
    holdQueue: IQueueMessage[];
}

export const holdQueuePriorityList: PushMessageType[] = [
    PushMessageType.KYCStatusChangedToPassed,
];

export const unpausableList: PushMessageType[] = [
    PushMessageType.TermsUpdate,
    PushMessageType.BrazilMigrationTerms,
];
